// extracted by mini-css-extract-plugin
export default {"controlsCard":"styles_controlsCard__0F5Jo","active":"styles_active__-OnDp","switch":"styles_switch__ItuWa","collapse":"styles_collapse__76nQV","cardMeta":"styles_cardMeta__gB1tx"};